/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as publicPublicImport } from './routes/(public)/_public'
import { Route as profileProfileImport } from './routes/(profile)/profile'
import { Route as authauthImport } from './routes/(auth)/__auth'
import { Route as appDashboardImport } from './routes/(app)/dashboard'
import { Route as publicPublicIndexImport } from './routes/(public)/_public/index'
import { Route as profileProfileIndexImport } from './routes/(profile)/profile/index'
import { Route as appDashboardIndexImport } from './routes/(app)/dashboard/index'
import { Route as authauthResetPasswordImport } from './routes/(auth)/__auth/reset-password'
import { Route as authauthRegisterImport } from './routes/(auth)/__auth/register'
import { Route as authauthLoginImport } from './routes/(auth)/__auth/login'
import { Route as authauthForgotPasswordImport } from './routes/(auth)/__auth/forgot-password'
import { Route as appDashboardConversionHistoryIdImport } from './routes/(app)/dashboard/conversion-history/$id'

// Create Virtual Routes

const publicImport = createFileRoute('/(public)')()
const authImport = createFileRoute('/(auth)')()

// Create/Update Routes

const publicRoute = publicImport.update({
  id: '/(public)',
  getParentRoute: () => rootRoute,
} as any)

const authRoute = authImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRoute,
} as any)

const publicPublicRoute = publicPublicImport.update({
  id: '/_public',
  getParentRoute: () => publicRoute,
} as any)

const profileProfileRoute = profileProfileImport.update({
  id: '/(profile)/profile',
  path: '/profile',
  getParentRoute: () => rootRoute,
} as any)

const authauthRoute = authauthImport.update({
  id: '/__auth',
  getParentRoute: () => authRoute,
} as any)

const appDashboardRoute = appDashboardImport.update({
  id: '/(app)/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRoute,
} as any)

const publicPublicIndexRoute = publicPublicIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => publicPublicRoute,
} as any)

const profileProfileIndexRoute = profileProfileIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => profileProfileRoute,
} as any)

const appDashboardIndexRoute = appDashboardIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appDashboardRoute,
} as any)

const authauthResetPasswordRoute = authauthResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => authauthRoute,
} as any)

const authauthRegisterRoute = authauthRegisterImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => authauthRoute,
} as any)

const authauthLoginRoute = authauthLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => authauthRoute,
} as any)

const authauthForgotPasswordRoute = authauthForgotPasswordImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => authauthRoute,
} as any)

const appDashboardConversionHistoryIdRoute =
  appDashboardConversionHistoryIdImport.update({
    id: '/conversion-history/$id',
    path: '/conversion-history/$id',
    getParentRoute: () => appDashboardRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(app)/dashboard': {
      id: '/(app)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof appDashboardImport
      parentRoute: typeof rootRoute
    }
    '/(auth)': {
      id: '/(auth)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/__auth': {
      id: '/(auth)/__auth'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authauthImport
      parentRoute: typeof authRoute
    }
    '/(profile)/profile': {
      id: '/(profile)/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof profileProfileImport
      parentRoute: typeof rootRoute
    }
    '/(public)': {
      id: '/(public)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicImport
      parentRoute: typeof rootRoute
    }
    '/(public)/_public': {
      id: '/(public)/_public'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicPublicImport
      parentRoute: typeof publicRoute
    }
    '/(auth)/__auth/forgot-password': {
      id: '/(auth)/__auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authauthForgotPasswordImport
      parentRoute: typeof authauthImport
    }
    '/(auth)/__auth/login': {
      id: '/(auth)/__auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authauthLoginImport
      parentRoute: typeof authauthImport
    }
    '/(auth)/__auth/register': {
      id: '/(auth)/__auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof authauthRegisterImport
      parentRoute: typeof authauthImport
    }
    '/(auth)/__auth/reset-password': {
      id: '/(auth)/__auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authauthResetPasswordImport
      parentRoute: typeof authauthImport
    }
    '/(app)/dashboard/': {
      id: '/(app)/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof appDashboardIndexImport
      parentRoute: typeof appDashboardImport
    }
    '/(profile)/profile/': {
      id: '/(profile)/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof profileProfileIndexImport
      parentRoute: typeof profileProfileImport
    }
    '/(public)/_public/': {
      id: '/(public)/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicPublicIndexImport
      parentRoute: typeof publicPublicImport
    }
    '/(app)/dashboard/conversion-history/$id': {
      id: '/(app)/dashboard/conversion-history/$id'
      path: '/conversion-history/$id'
      fullPath: '/dashboard/conversion-history/$id'
      preLoaderRoute: typeof appDashboardConversionHistoryIdImport
      parentRoute: typeof appDashboardImport
    }
  }
}

// Create and export the route tree

interface appDashboardRouteChildren {
  appDashboardIndexRoute: typeof appDashboardIndexRoute
  appDashboardConversionHistoryIdRoute: typeof appDashboardConversionHistoryIdRoute
}

const appDashboardRouteChildren: appDashboardRouteChildren = {
  appDashboardIndexRoute: appDashboardIndexRoute,
  appDashboardConversionHistoryIdRoute: appDashboardConversionHistoryIdRoute,
}

const appDashboardRouteWithChildren = appDashboardRoute._addFileChildren(
  appDashboardRouteChildren,
)

interface authauthRouteChildren {
  authauthForgotPasswordRoute: typeof authauthForgotPasswordRoute
  authauthLoginRoute: typeof authauthLoginRoute
  authauthRegisterRoute: typeof authauthRegisterRoute
  authauthResetPasswordRoute: typeof authauthResetPasswordRoute
}

const authauthRouteChildren: authauthRouteChildren = {
  authauthForgotPasswordRoute: authauthForgotPasswordRoute,
  authauthLoginRoute: authauthLoginRoute,
  authauthRegisterRoute: authauthRegisterRoute,
  authauthResetPasswordRoute: authauthResetPasswordRoute,
}

const authauthRouteWithChildren = authauthRoute._addFileChildren(
  authauthRouteChildren,
)

interface authRouteChildren {
  authauthRoute: typeof authauthRouteWithChildren
}

const authRouteChildren: authRouteChildren = {
  authauthRoute: authauthRouteWithChildren,
}

const authRouteWithChildren = authRoute._addFileChildren(authRouteChildren)

interface profileProfileRouteChildren {
  profileProfileIndexRoute: typeof profileProfileIndexRoute
}

const profileProfileRouteChildren: profileProfileRouteChildren = {
  profileProfileIndexRoute: profileProfileIndexRoute,
}

const profileProfileRouteWithChildren = profileProfileRoute._addFileChildren(
  profileProfileRouteChildren,
)

interface publicPublicRouteChildren {
  publicPublicIndexRoute: typeof publicPublicIndexRoute
}

const publicPublicRouteChildren: publicPublicRouteChildren = {
  publicPublicIndexRoute: publicPublicIndexRoute,
}

const publicPublicRouteWithChildren = publicPublicRoute._addFileChildren(
  publicPublicRouteChildren,
)

interface publicRouteChildren {
  publicPublicRoute: typeof publicPublicRouteWithChildren
}

const publicRouteChildren: publicRouteChildren = {
  publicPublicRoute: publicPublicRouteWithChildren,
}

const publicRouteWithChildren =
  publicRoute._addFileChildren(publicRouteChildren)

export interface FileRoutesByFullPath {
  '/dashboard': typeof appDashboardRouteWithChildren
  '/': typeof publicPublicIndexRoute
  '/profile': typeof profileProfileRouteWithChildren
  '/forgot-password': typeof authauthForgotPasswordRoute
  '/login': typeof authauthLoginRoute
  '/register': typeof authauthRegisterRoute
  '/reset-password': typeof authauthResetPasswordRoute
  '/dashboard/': typeof appDashboardIndexRoute
  '/profile/': typeof profileProfileIndexRoute
  '/dashboard/conversion-history/$id': typeof appDashboardConversionHistoryIdRoute
}

export interface FileRoutesByTo {
  '/': typeof publicPublicIndexRoute
  '/forgot-password': typeof authauthForgotPasswordRoute
  '/login': typeof authauthLoginRoute
  '/register': typeof authauthRegisterRoute
  '/reset-password': typeof authauthResetPasswordRoute
  '/dashboard': typeof appDashboardIndexRoute
  '/profile': typeof profileProfileIndexRoute
  '/dashboard/conversion-history/$id': typeof appDashboardConversionHistoryIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/(app)/dashboard': typeof appDashboardRouteWithChildren
  '/(auth)': typeof authRouteWithChildren
  '/(auth)/__auth': typeof authauthRouteWithChildren
  '/(profile)/profile': typeof profileProfileRouteWithChildren
  '/(public)': typeof publicRouteWithChildren
  '/(public)/_public': typeof publicPublicRouteWithChildren
  '/(auth)/__auth/forgot-password': typeof authauthForgotPasswordRoute
  '/(auth)/__auth/login': typeof authauthLoginRoute
  '/(auth)/__auth/register': typeof authauthRegisterRoute
  '/(auth)/__auth/reset-password': typeof authauthResetPasswordRoute
  '/(app)/dashboard/': typeof appDashboardIndexRoute
  '/(profile)/profile/': typeof profileProfileIndexRoute
  '/(public)/_public/': typeof publicPublicIndexRoute
  '/(app)/dashboard/conversion-history/$id': typeof appDashboardConversionHistoryIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/dashboard'
    | '/'
    | '/profile'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/dashboard/'
    | '/profile/'
    | '/dashboard/conversion-history/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/dashboard'
    | '/profile'
    | '/dashboard/conversion-history/$id'
  id:
    | '__root__'
    | '/(app)/dashboard'
    | '/(auth)'
    | '/(auth)/__auth'
    | '/(profile)/profile'
    | '/(public)'
    | '/(public)/_public'
    | '/(auth)/__auth/forgot-password'
    | '/(auth)/__auth/login'
    | '/(auth)/__auth/register'
    | '/(auth)/__auth/reset-password'
    | '/(app)/dashboard/'
    | '/(profile)/profile/'
    | '/(public)/_public/'
    | '/(app)/dashboard/conversion-history/$id'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  appDashboardRoute: typeof appDashboardRouteWithChildren
  authRoute: typeof authRouteWithChildren
  profileProfileRoute: typeof profileProfileRouteWithChildren
  publicRoute: typeof publicRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  appDashboardRoute: appDashboardRouteWithChildren,
  authRoute: authRouteWithChildren,
  profileProfileRoute: profileProfileRouteWithChildren,
  publicRoute: publicRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/(app)/dashboard",
        "/(auth)",
        "/(profile)/profile",
        "/(public)"
      ]
    },
    "/(app)/dashboard": {
      "filePath": "(app)/dashboard.tsx",
      "children": [
        "/(app)/dashboard/",
        "/(app)/dashboard/conversion-history/$id"
      ]
    },
    "/(auth)": {
      "filePath": "(auth)",
      "children": [
        "/(auth)/__auth"
      ]
    },
    "/(auth)/__auth": {
      "filePath": "(auth)/__auth.tsx",
      "parent": "/(auth)",
      "children": [
        "/(auth)/__auth/forgot-password",
        "/(auth)/__auth/login",
        "/(auth)/__auth/register",
        "/(auth)/__auth/reset-password"
      ]
    },
    "/(profile)/profile": {
      "filePath": "(profile)/profile.tsx",
      "children": [
        "/(profile)/profile/"
      ]
    },
    "/(public)": {
      "filePath": "(public)",
      "children": [
        "/(public)/_public"
      ]
    },
    "/(public)/_public": {
      "filePath": "(public)/_public.tsx",
      "parent": "/(public)",
      "children": [
        "/(public)/_public/"
      ]
    },
    "/(auth)/__auth/forgot-password": {
      "filePath": "(auth)/__auth/forgot-password.tsx",
      "parent": "/(auth)/__auth"
    },
    "/(auth)/__auth/login": {
      "filePath": "(auth)/__auth/login.tsx",
      "parent": "/(auth)/__auth"
    },
    "/(auth)/__auth/register": {
      "filePath": "(auth)/__auth/register.tsx",
      "parent": "/(auth)/__auth"
    },
    "/(auth)/__auth/reset-password": {
      "filePath": "(auth)/__auth/reset-password.tsx",
      "parent": "/(auth)/__auth"
    },
    "/(app)/dashboard/": {
      "filePath": "(app)/dashboard/index.tsx",
      "parent": "/(app)/dashboard"
    },
    "/(profile)/profile/": {
      "filePath": "(profile)/profile/index.tsx",
      "parent": "/(profile)/profile"
    },
    "/(public)/_public/": {
      "filePath": "(public)/_public/index.tsx",
      "parent": "/(public)/_public"
    },
    "/(app)/dashboard/conversion-history/$id": {
      "filePath": "(app)/dashboard/conversion-history/$id.tsx",
      "parent": "/(app)/dashboard"
    }
  }
}
ROUTE_MANIFEST_END */
